import * as React from 'react'

import { useBloomreach } from '@grandvisionhq/bloomreach'
import { PromoteInstallments } from '@grandvisionhq/fun-products'

import { graphPromoteInstallmentsConfiguration } from '../../configuration'

type Props = Pick<
  React.ComponentPropsWithoutRef<typeof PromoteInstallments>,
  'productType' | 'textAlign'
>

export const PromoteInstallmentsGraphContainer = (props: Props) => {
  const { siteLogos } = useBloomreach()

  return (
    <PromoteInstallments
      siteLogos={siteLogos}
      numberOfInstallments={graphPromoteInstallmentsConfiguration.numberOfInstallments}
      minimumPrice={graphPromoteInstallmentsConfiguration.minimumPrice}
      productType={props.productType}
      textAlign={props.textAlign}
    />
  )
}
